import React from 'react'
import { t } from '../../../providers/i18nProvider/i18nProvider'
import { punditStore } from '../../stores/punditStore'
import { vote } from '../../actions/punditActions'
import BaseComponent from '../../../application/baseComponent'

const PUNDIT_SELECTION_VALUES = ['1', 'x', '2']

export default class PunditVbetSelectionComponent extends BaseComponent {
  constructor(props) {
    super(props, [punditStore])
  }

  getState(props) {
    let [homeTeam, draw, awayTeam] = punditStore.captions
    return { homeTeam, draw, awayTeam }
  }

  handleSelection(e, hybridRedirect = true) {
    vote(e.target.value, hybridRedirect)
  }

  getLabel(value, index) {
    let selectionValue = `selection_${value}`
    return (
      <label
        className="pundit-vbet-component__selection__btn"
        key={`selection_label_${index}`}
        htmlFor={selectionValue}
      >
        {index !== 1 ? value : ''}
      </label>
    )
  }

  getInput(value, index) {
    let selectionValue = `selection_${value}`
    return (
      <input
        className="pundit-vbet-component__selection__input"
        ref={`selection_input_${index}`}
        id={selectionValue}
        key={`selection_input_${index}`}
        type="radio"
        value={value}
        hidden
        name="selection"
        onChange={this.handleSelection.bind(this)}
      />
    )
  }

  render() {
    let view = []
    PUNDIT_SELECTION_VALUES.forEach((value, index) => {
      view.push(this.getInput(value, index))
      view.push(this.getLabel(value, index))
    })
    let { homeTeam, draw, awayTeam } = this.state
    return (
      <div>
        <div className="pundit-section-heading">
          <h1 className="pundit-section-heading__text">{t('pundit.what_your_prediction')}</h1>
        </div>
        <div className="pundit-vbet-component__selection">
          {view}
          <ul className="pundit-vbet-component__selection__captions">
            <li className="pundit-vbet-component__selection__captions__label">{homeTeam}</li>
            <li className="pundit-vbet-component__selection__captions__label">{draw}</li>
            <li className="pundit-vbet-component__selection__captions__label">{awayTeam}</li>
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/pundit/punditVbetSelectionComponent.js